// extracted by mini-css-extract-plugin
module.exports = {"container":"Document_container__3uGzK","wrapper":"Document_wrapper__1CojY","children":"Document_children__1YoT_"};